var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16H13C14.6569 16 16 14.6574 16 13.0005V6L10 0H3.00007C1.34322 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16Z",
    fill: "url(#paint0_linear_307_241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H3C1.48122 15.75 0.25 14.5188 0.25 13V3C0.25 1.48123 1.48128 0.25 3.00007 0.25H9.89645L15.75 6.10355V13.0005C15.75 14.5192 14.5188 15.75 13 15.75Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.6C2 8.26863 2.26208 8 2.58537 8L8.02439 8C8.34768 8 8.60976 8.26863 8.60976 8.6C8.60976 8.93137 8.34768 9.2 8.02439 9.2H2.58537C2.26208 9.2 2 8.93137 2 8.6ZM2 11C2 10.6686 2.26208 10.4 2.58537 10.4H9.41463C9.73792 10.4 10 10.6686 10 11C10 11.3314 9.73792 11.6 9.41463 11.6H2.58537C2.26208 11.6 2 11.3314 2 11ZM2 13.4C2 13.0686 2.26208 12.8 2.58537 12.8H7.09756C7.42085 12.8 7.68293 13.0686 7.68293 13.4C7.68293 13.7314 7.42085 14 7.09756 14H2.58537C2.26208 14 2 13.7314 2 13.4Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "url(#paint1_linear_307_241)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_241",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_241",
    x1: 1,
    y1: 1,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#FDFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#FCFCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#FBFBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#FAFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#F9F9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#F9F8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#F8F7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#F7F6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#F6F5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#F5F4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#F4F3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#F3F3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_241",
    x1: 13,
    y1: 3,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFile);
export default __webpack_public_path__ + "static/media/document-file.3850fea8c03f3efb1dc538b5759d6725.svg";
export { ForwardRef as ReactComponent };